module.exports = __webpack_public_path__ + "static/media/programming.15861e3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/programming.jpg
// module id = 353
// module chunks = 0